import { ContractStatus, MemberContract } from '@lib/core/models/contract.interface';

export function findActiveContract(contracts: MemberContract[]): MemberContract | null {
  if (contracts.length === 0) {
    return null;
  }
  const activeContracts = contracts.filter(contract => contract.status === ContractStatus.Active);
  return activeContracts.length > 0
    ? activeContracts.reduce((max, current) => (current.activeTo > max.activeTo ? current : max))
    : contracts.reduce((max, current) => (current.activeTo > max.activeTo ? current : max));
}

export function calculatePolicyTerms(contract: MemberContract): number | null {
  const timeDifference: number = Math.abs(new Date(contract.activeTo).getTime() - new Date().getTime());
  if (!!contract.activatedAt && new Date(contract.activeTo) > new Date()) {
    return Math.floor(timeDifference / (1000 * 3600 * 24));
  }
  return null;
}
